// extracted by mini-css-extract-plugin
export default {"QRCodePop":"QRCodePop_QRCodePop__2AM9a"};